var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8047 1.25781L0.398438 10.123C-0.199219 10.4551 -0.132812 11.3184 0.464844 11.5508L4.01758 13.0449L13.5469 4.64453C13.7129 4.47852 13.9785 4.71094 13.8125 4.91016L5.84375 14.6387V17.3281C5.84375 18.125 6.77344 18.4238 7.23828 17.8594L9.36328 15.2695L13.4805 17.0293C13.9453 17.2285 14.5098 16.9297 14.5762 16.3984L16.9668 2.05469C17.0996 1.39062 16.3691 0.925781 15.8047 1.25781Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/Sent.7ecec08e18865a669dfa21e3f9b9f611.svg";
export { ForwardRef as ReactComponent };